import { makeSelectABTestVariationId } from 'containers/AppContainer/selectors';
import { useSelector } from 'react-redux';

export const useGetABTestVariant = (experiment: string) =>
  useSelector(makeSelectABTestVariationId(experiment));
